import { AxiosError } from 'axios';
import { left, right } from '../../../../shared/core/Either';
import { Result } from '../../../../shared/core/Result';
import { APIResponse } from '../../../../shared/infra/api/APIResponse';
import { BaseAPI } from '../../../../shared/infra/api/BaseAPI';
import { IAuthService } from '../../../users/services/authService';
import { BasicGroupsResponseDTO } from '../../members/dtos/BasicGroup.dto';
import { BasicGroupsModel } from '../../members/models/BasicGroups.model';
import { BasicGroupUtil } from '../utils/BasicGroupUtil';

export interface IBasicGroupService {
  getBasicGroups(): Promise<APIResponse<BasicGroupsModel[]>>;
}

export class BasicGroupService extends BaseAPI implements IBasicGroupService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onFailureExecuteImpl(error: AxiosError<any>): Promise<any> {
    throw new Error('Method not implemented.');
  }

  constructor(authService: IAuthService) {
    super(authService);
  }

  hasToken(): boolean {
    return this.authService.isUserAuthenticated();
  }

  public async getBasicGroups(): Promise<APIResponse<BasicGroupsModel[]>> {
    try {
      const response = await this.get<BasicGroupsResponseDTO>({
        url: '/v1/groups/basic',
        requiresToken: true,
      });

      const basicGroups = response.data.groups;
      return right(
        Result.ok<BasicGroupsModel[]>(
          basicGroups.map((item) => BasicGroupUtil.mapToViewModel(item)),
        ),
      );
    } catch (err: any) {
      return left(err.response ? err.response.data : 'Connection failed');
    }
  }
}
